<template>
  <div class="container">
    <PublicHeader :totalName="$t('common').title" />
    <div class="Info">
      <!-- 充币 -->
      <div class="item" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="recharge_currency" />
        <div class="txt">{{ $t('common').Depositcoins }}</div>
      </div>
      <!-- 法币入金 -->
      <!-- <div class="item" @click="$goRecharge('Recharge')" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="recharge" />
        <div class="txt">{{ $t('common').Rechargefiatcurrency }}</div>
      </div> -->
      <!-- 取款 -->
      <div class="item" @click="$router.push({ name: 'WithCurrency' })" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="with" />
        <div class="txt">{{ $t('common').Withdraw }}</div>
      </div>
      <!-- 划转 -->
      <div class="item" @click="$router.push({ name: 'AssetTransfer' })">
        <svg-icon class-name="svgs" icon-class="transfer" />
        <div class="txt">{{ $t('asset').Transfer }}</div>
      </div>
      <!-- 闪兑 -->
      <div class="item" @click="$router.push({ name: 'AssetFlashcash' })">
        <svg-icon class-name="svgs" icon-class="flashcash" />
        <div class="txt">{{ $t('asset').flashcash }}</div>
      </div>
      <!-- C2C -->
      <div class="item" @click="$router.push({ name: 'C2c' })" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="c2c" />
        <div class="txt">C2C</div>
      </div>
      <!-- 理财 -->
      <div class="item" @click="$router.push({ name: 'Finance' })" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="heel" />
        <div class="txt">{{ $t('common').documentation }}</div>
      </div>
      <!-- 贷款 -->
      <div class="item" @click="$router.push({ name: 'Loan' })" v-if="isOpenLoan&&!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="loan" />
        <div class="txt">{{ $t('finance').loan }}</div>
      </div>
      <!-- 活动中心 -->
      <!-- <div class="item" @click="$router.push({ name: 'Activity' })">
        <svg-icon class-name="svgs" icon-class="activity" />
        <div class="txt">{{ $t('common').Activecenter }}</div>
      </div> -->
      <!-- 邀请返佣 -->
      <div class="item" @click="$router.push({ name: 'Share' })">
        <svg-icon class-name="svgs" icon-class="share" />
        <div class="txt">{{ $t('common').Invitationforrebate }}</div>
      </div>
      <!-- 资金明细 -->
      <div class="item" @click="$router.push({ name: 'Bill' })">
        <svg-icon class-name="svgs" icon-class="bill" />
        <div class="txt">{{ $t('common').Detailsoffunds }}</div>
      </div>
      <!-- 持仓明细 -->
      <div class="item" @click="$router.push({ name: 'Position' })">
        <svg-icon class-name="svgs" icon-class="position" />
        <div class="txt">{{ $t('common').Positiondetails }}</div>
      </div>
      <!-- 公告 -->
      <!-- <div class="item" @click="$router.push({ name: 'Notice' })">
        <svg-icon class-name="svgs" icon-class="bell" />
        <div class="txt">{{ $t('common').Notice }}</div>
      </div> -->
      <!-- 关于我们 -->
      <div class="item" @click="$router.push({ name: 'About' })">
        <svg-icon class-name="svgs" icon-class="about" />
        <div class="txt">{{ $t('common').Aboutus }}</div>
      </div>
      <!-- 帮助中心 -->
      <div class="item" @click="goServe">
        <svg-icon class-name="svgs" icon-class="help" />
        <div class="txt">{{ $t('common').helpcenter }}</div>
      </div>
      <!-- 客服 -->
      <div class="item" @click="goServe">
        <svg-icon class-name="svgs" icon-class="service" />
        <div class="txt">{{ $t('common').customer }}</div>
      </div>
    </div>
    <!-- 取款选择 -->
    <van-popup v-model="showWithSelect" position="bottom" closeable>
      <div class="withSelInfo">
        <div class="tit">{{ $t('common').Withdraw }}</div>
        <div class="tabs" @click="$router.push({ name: 'WithCurrency' })">{{ $t('common').Cryptocurrencywithdrawal }}
          <span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span>
        </div>
        <div class="tabs" @click="$router.push({ name: 'With' })">{{ $t('common').Fiatmoneywithdrawal }}<span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'
import systemApi from '@/api/system'
import userApi from '@/api/user'

export default {
  components: {
    PublicHeader,
  },
  data() {
    return {
      showWithSelect: false,
      isOpenLoan: false,
    }
  },
  computed: {
    ...mapGetters(['basicConfig', 'connection', 'baseMsg']),
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    async getConfig() {
      const res = await systemApi.getConfig()
      this.isOpenLoan = res.systemSetting.isOpenLoan
    },
    // 客服
    async goServe() {
      // const res = await systemApi.getConfig()
      // location.href = res.systemSetting.serviceUrl
      const res = await userApi.getMemberInfo()
      const encodedData = JSON.stringify({ name: res.user.memberId, email: res.user.memberName });
      location.href = 'chatlinkonline.html?metadata=' + encodedData
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .Info {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;

    .item {
      margin-top: 50px;
      width: 25%;
      text-align: center;

      .svgs {
        width: 25px;
        height: 25px;
        color: var(--text_color);
      }

      .txt {
        margin-top: 10px;
        font-size: 12px;
        color: var(--text_color);
      }
    }
  }

  .withSelInfo {
    padding: 20px;

    .tit {
      margin-bottom: 30px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
    }

    .tabs {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      color: var(--text_color);
      background: var(--info_color);
      border-radius: 10px;
      padding: 20px;
    }
  }
}

::v-deep .van-popup--bottom {
  border-radius: 10px 10px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 15px;
  color: var(--ntext_color);
}
</style>
